import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'tf-date-display',
  standalone: true,
  template: `<span>{{ formatted() }}</span>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateDisplayComponent {
  readonly value = input<unknown>();

  readonly formatted = computed<string>(() => {
    const v = this.value();
    if (v == null || v === '') return '—';
    const d = new Date(v as string);
    return Number.isNaN(d.getTime()) ? String(v) : d.toLocaleDateString();
  });
}
